import '../scss/app.scss'; // Importing SCSS file


  

/**
 * Function for Techmer to control their search page
 * @param {string} query_input - The input field for the search query
 * @param {string} query_search_button - The button to submit the search query
 * @param {string} problem_solver_iframe - The iframe that displays the search results
 * @param {string} search_params - The search parameters from the URL
 * @param {string} search_query - The search query from the URL
 * @param {string} iframe - The iframe that displays the search results
 * @param {string} iframeTop - The top position of the iframe
 * @param {string} url - The URL of the page
 * @param {string} seach_url - The URL of the page with the search query
 * @param {string} spinner - The spinner that displays while the search results are loading
 * @param {string} text - The text that displays while the search results are loading
 * @param {string} element - The element that the spinner waits for before removing itself
 * @param {string} str - The search query
 * 
 * Version: 1.0.0
 * Author: Gino Peterson
 * Created: Jul 14,2023
 * Last Updated: Jul 14,2023
 * Version Control: 
 */



function __techmer_Js() {
    // Cache the DOM
    const query_input = document.getElementById("query");
    const query_search_button = document.getElementById("query-search-button");
    const problem_solver_iframe = document.getElementById(
      "problem-solver-iframe"
    );
    const search_params = new URLSearchParams(window.location.search);
    const search_query = search_params.get("search");
    // if search query true spin loader until iframe is loaded
  
    if(search_query){
    let iframe = iFrameAddition(search_query);
    search_query && document.getElementById("search-results").append(iframe);
    search_query && spinner(true, "problem-solver-iframe", "Loading results");
  //  sroll iframe into view smoothly
      search_query && iframe.scrollIntoView({ behavior: "smooth" });
  
      }
  
  
  
   
    // Collect Variables
  
    // Preplexity Start here
    // When Search Button is clicked or Enter key is pressed, run the function
    const handleSearch = () => {
      // When the function begins, check if the query input is empty and alert the user to add a value
      if (query_input.value === "") {
        alert("Please enter a search query.");
        return;
      }
  
      //  get url
      let url = new URL(window.location.href);
      let correct_host =  url.hostname.includes('localhost') ? url.host : url.hostname;
      let query = query_input.value;
      let search_url =
  
     
        url.protocol +
        "//" +
        correct_host +
        url.pathname +
        "?search=" +
         query
      // check if browser is safari and if so open search_url in new tab
      let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
      // check if user device is apple 
      let isApple = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
      let isMobile =  window.innerWidth < 768 ? true : false;
      let iframe_page = IframeLinkGenerator(query);
      
      if (isSafari || isMobile) {
        isMobile  ? (window.location.href = iframe_page ):  window.open(iframe_page , "_blank");
      // reset input field
      query_input.value = "";
  
  
      } else {
      window.location.href = search_url;
      spinner(false);
      
      }
    }; 
  
    function spinner(removeWhenDone, elementToWaitFor, text = null) {
      text = text || "Searching for results";
      let spinner = document.createElement("div");
      spinner.className = "spinner";
      spinner.innerHTML = `<div class="spinner-text">${text}</div>
      <div class="spinner-icon"></div>`;
      document.body.append(spinner);
      // if remove when done is true, remove the spinner when the elementToWaitFor is loaded
      let element;
      if (removeWhenDone) {
        window.addEventListener("load", () => {
          spinner && spinner.remove();
        });
        setTimeout(() => {
          spinner.remove();
        }, 3000);
      }
    }
  
    query_search_button.addEventListener("click", handleSearch);
    query_input.addEventListener("keydown", (event) => {
      // Check if the Enter key is pressed (key code 13)
  
      if (event.key === "Enter") {
        handleSearch();
      }
    });
    // Preplexity end here
  
    function iFrameAddition(str) {
      let iframe = document.createElement("iframe");
      iframe.id = "problem-solver-iframe";
      iframe.src =  IframeLinkGenerator(str);
      iframe.width = "100%";
      iframe.height = "800";
      iframe.frameBorder = "0";
      // add sandox to prevent malicous code but allow ifame to load content
      iframe.sandbox = "allow-same-origin allow-scripts allow-popups allow-forms";
  
  
  
      return iframe;
    }
  
    function IframeLinkGenerator(str) {
       return `https://catalog.ides.com/QuickSearch.aspx?I=46454&query=${str}`;
    }
   
  }
  
   document.getElementById("query") && __techmer_Js();
   
  //  get staff cards
  const staff_cards = [...document.querySelectorAll(".staff-card")];
  //  loop through staff_cards and add event listener to each
  staff_cards.forEach((card) => {
    card.onclick = function(e){
      let a = card.querySelector('a');
      a.click();
    }
  }) 
   